import React, { useState } from 'react';
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";
import config from "../../config";
import {
    Button,
    Modal,
    FormGroup,
    Label,
    Input,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Alert,
    Row,
  } from "reactstrap";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from '../../utils/helper';

const OrderSearch = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [results, setResults] = useState([]);
    const [spinnerLoading, serSpinnerLoading] = useState(false);
    
    
    const handleSearch = async () => {
        try {
            // console.log('searchQuery',searchQuery)
            
            serSpinnerLoading(true);
            let storeInformation = JSON.parse(localStorage.getItem('storeInformation'));
            let authToken = storeInformation.token   
            var vtimestamp = generateEpochTimestamp();
            
            const response = await fetch(config.getHost() + "/product/get_order_status_list/", {
                method: "POST",
                headers: {
                    Authorization: `Token ${authToken}`,
                    'Content-Type': 'application/json',
                    Timestamp: vtimestamp,
                    Signature: generateSignature(vtimestamp, authToken)
                  },
                body: JSON.stringify({
                  order_id: searchQuery
                }),    
            });
            
            if (response.status === 200){
                let jsonres = await response.json();
                    console.log('response', jsonres)
                    if (jsonres.success && jsonres.result){
                    
                        setResults(jsonres.result);
                    }
                    
                    serSpinnerLoading(false);
                }
            else{
                console.log('order search',response.status)
                
                serSpinnerLoading(false);
                }
        
        } catch (error) {
            console.error('Error fetching data:', error);
            serSpinnerLoading(false);
            
        }
    };

    const handleClear = () => {
        setSearchQuery('');
        setResults([]);
    };

    return (
        
        <div>
             <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <h2>Order Audit Log</h2>
              </div>      
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search orders..."
            />
            <Button style={{color:"primary"}}  onClick={handleSearch}>Search</Button>
            <Button style={{color:"secondary"}}  onClick={handleClear}>Clear</Button>
            </div>
            <LoadingOverlay
          active={spinnerLoading}
          spinner
          text="Loading ..."
        >
            {results.length > 0 && (
              <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%', marginTop: '20px' }}>
              <thead>
                  <tr style={{ border: '1px solid black' }}>
                      <th style={{ border: '1px solid black', padding: '8px' }}>Order ID</th>
                      <th style={{ border: '1px solid black', padding: '8px' }}>Status</th>
                      <th style={{ border: '1px solid black', padding: '8px' }}>Status Created At</th>
                      <th style={{ border: '1px solid black', padding: '8px' }}>Comments</th>
                  </tr>
              </thead>
              <tbody>
                  {results.map((item, index) => (
                      <tr key={index} style={{ border: '1px solid black' }}>
                          <td style={{ border: '1px solid black', padding: '8px' }}>{item.node.order_id}</td>
                          <td style={{ border: '1px solid black', padding: '8px' }}>{item.node.status}</td>
                          <td style={{ border: '1px solid black', padding: '8px' }}>{new Date(item.node.status_created_at).toLocaleString()}</td>
                          <td style={{ border: '1px solid black', padding: '8px' }}>{item.node.comments}</td>
                      </tr>
                  ))}
              </tbody>
          </table>
            )}
            </LoadingOverlay>
        </div>
    );
};

export default OrderSearch;



// WEBPACK FOOTER //
// ./src/pages/OrderHistory/OrderSearch.js